import $ from "jquery";
import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs, Keyboard } from 'swiper/modules';
import photoswipe from 'photoswipe';
import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js';


import lottie from 'lottie-web/build/player/lottie_light.min.js'


export function singleProperty() {
	let flatpickrInstance = null; // Reference to the Flatpickr instance
	
	let currentDates = null;
	var currentMonth = 0;
	let map;

	var arrivalDate, checkoutDate, numberOfNights;

	function formatDate(date) {
		var day = date.getDate();
		var monthIndex = date.getMonth();
		var year = date.getFullYear();

		var suffixes = ["th", "st", "nd", "rd"];
		var dayMod10 = day % 10;
		var suffix = (dayMod10 > 3 || Math.floor(day / 10) === 1) ? suffixes[0] : suffixes[dayMod10];

		var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
		return `${day}${suffix} ${months[monthIndex]} ${year}`;
	}

	function formatDateDDMMYYYY(date) {

		//Check if date is a string and already in correct format (dd/mm/yyyy)
		if (typeof date === 'string' && date.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
			console.log('date already in correct format', date);
			return date;
		}

		// Extract the day, month, and year from the date object
		
		var day = date.getDate();
		var month = date.getMonth() + 1; // Months are 0-based
		var year = date.getFullYear();

		// Pad the day and month with a leading zero if they are less than 10
		day = day < 10 ? '0' + day : day;
		month = month < 10 ? '0' + month : month;

		// Concatenate the parts with slashes to match the desired format
		return day + '/' + month + '/' + year;
	}

	function formatDateYYYYMMDD(date) {

		//Check if date is a string and already in correct format (dd/mm/yyyy)
		if (typeof date === 'string' && date.match(/^\d{4}\/\d{2}\/\d{2}$/)) {
			console.log('date already in correct format', date);
			return date;
		}

		// Extract the day, month, and year from the date object
		
		var day = date.getDate();
		var month = date.getMonth() + 1; // Months are 0-based
		var year = date.getFullYear();

		// Pad the day and month with a leading zero if they are less than 10
		day = day < 10 ? '0' + day : day;
		month = month < 10 ? '0' + month : month;

		// Concatenate the parts with slashes to match the desired format
		return year + '-' + month + '-' + day;
	}


	function initPropertyImageSwiper() {
		var mainPhotoSwiper = new Swiper('.property-swiper-container', {

			modules: [Navigation, Pagination, Keyboard],
			// Swiper options here
			slidesPerView: 1,
			lazy: true,
			pagination: {
				el: ".swiper-pagination",
				type: "fraction",
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			keyboard: {
				enabled: true,
			},
			loop: true,
		});

		$(document).on('click', '.property-swiper .swiper-thumb', function (e) {
			e.preventDefault();
			var slideToGoTo = $(this).data('to-slide');
			mainPhotoSwiper.slideTo(slideToGoTo);
			return false;
		});

		const lightbox = new PhotoSwipeLightbox({
			gallery: '#property-swiper-container',
			children: 'a',
			pswpModule: () => import('photoswipe')
		});
		lightbox.init();
	}

	function initPropertyDate() {
		
	}

	// Function to initialize or update Flatpickr
	function initializeOrUpdateFlatpickr(disabledDates, currentDates) {
		if (flatpickrInstance) {
			// Update the existing Flatpickr instance
			flatpickrInstance.set("disable", disabledDates);
			flatpickrInstance.redraw();
			console.log('redraw');
		} 
	}

	function noneAvailable() {

		let content;
		//Clone the no-availability div and insert into .flatpickr-innerContainer
		$('.flatpickr-no-availability').remove();
		content = $('.no-availability').clone().removeClass('hidden').addClass('flatpickr-no-availability absolute h-full bg-[#0a06068c] p-4 sm:p-5');
		$('.flatpickr-innerContainer').append(content);


		//$('.no-availability-month').removeClass('hidden');
		$('.number-of-nights').html($('select[name="nights"]').val());
		//Get month name

		var propertyName = $('h1').data('property-name');
		$('.property-name').html(propertyName);

		$('.loading-screen').addClass('hidden');
		removeLoadingAnimation();
	}

	$

	function retrieveDates() {
		initLoadingAnimation();
		$('.loading-screen').removeClass('hidden');
		$('.selection').addClass('hidden');

		var propertyId = $('[data-single-property-id]').data('single-property-id');
		numberOfNights = $('select[name="nights"]').val();

		if (isNaN(numberOfNights)) {
			numberOfNights = 1;
		}

		$.ajax({
			url: ajax.ajaxurl, // Ensure ajax.ajaxurl is correctly defined
			method: "POST",
			data: {
				action: "fetch_property_availability",
				property_id: propertyId,
				number_of_nights: numberOfNights
			},
			success: function (response) {
				currentDates = response;

				console.log('response', response);

				if(response.availability === 'none') {
					flatpickrInstance = flatpickr('#check_in', {
						dateFormat: 'Y-m-d',
						minDate: 'today',
						inline: true,
						maxDate: new Date().fp_incr(730), // 2 years from now
						disable: [
							{
								from: "2024-01-01",
								to: "2027-01-01"
							}
						],
						locale: {
							firstDayOfWeek: 1
						}
					});

					flatpickrInstance.changeMonth(currentMonth);
					console.log('currentMonth', currentMonth);

					noneAvailable();

					$('.calendar-container').removeClass('hidden');

					return;
				} else {
					$('.no-availability').addClass('hidden');

					var disabledDates = response.reduce(function (acc, item) {
						if (!item.availability) acc.push(item.startdate);
						return acc;
					}, []);

				}

				$('.calendar-container').removeClass('hidden');


				// Initialize or update Flatpickr with the fetched data
				flatpickrInstance = flatpickr('#check_in', {
					dateFormat: 'Y-m-d',
					minDate: 'today',
					inline: true,
					defaultDate: "2024-07-01",
					maxDate: new Date().fp_incr(730), // 2 years from now
					disable: disabledDates,
					locale: {
						firstDayOfWeek: 1
					},
					onReady: function (selectedDates, dateStr, instance) {
						markAvailableDates(instance);
					},
					onMonthChange: function (selectedDates, dateStr, instance) {
						markAvailableDates(instance);
						handleMonthChange(selectedDates, dateStr, instance);
					},
					onDayCreate: function (dObj, dStr, fp, dayElem) {
						// Adjust dayElem's date for timezone offset before formatting
						var offset = dayElem.dateObj.getTimezoneOffset(); // Get the timezone offset in minutes
						var localDate = new Date(dayElem.dateObj.getTime() - (offset * 60 * 1000)); // Adjust the date to local timezone
						var dateStr = localDate.toISOString().split('T')[0]; // Convert adjusted date to "YYYY-MM-DD" format


						// Find matching date object in currentDates
						var matchingDate = currentDates.find(function (dateObj) {
							return dateObj.startdate === dateStr;
						});

						// If a match is found and there's availability info, append it
						if (matchingDate && matchingDate.availability) {

							// Format price to remove decimal places and round down
							var price = Math.floor(matchingDate.availability);


							var priceElem = document.createElement("span");
							priceElem.className = "flatpickr-day-price";
							priceElem.textContent = "£" + price;

							dayElem.appendChild(priceElem);

							//Add class to dayElem
							dayElem.classList.add('available');

							// Mark next 7 days as available
							/*for (let i = 1; i <= 7; i++) {
								var nextDate = new Date(localDate);
								nextDate.setDate(nextDate.getDate() + i);
								var nextDateStr = nextDate.toISOString().split('T')[0];
								var nextMatchingDate = currentDates.find(function (dateObj) {
									return dateObj.startdate === nextDateStr;
								});
								var nextDateFormatted = nextDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });


								// If the next matching date is found
								if (nextMatchingDate) {
									console.log('nextMatchingDate', nextMatchingDate);
									console.log('nextDateFormatted', nextDateFormatted);
									// Add class to the day element of the next matching date
									$('.flatpickr-day[aria-label="' + nextDateFormatted + '"]').addClass('available');
								}
							}*/
						}
					},
					onChange: function (selectedDates, dateStr, instance) {
						markAvailableDates(instance);

						// Assuming length of stay is a predefined value or selected by the user elsewhere
						var lengthOfStay = $('select[name="nights"]').val(); // Example: getting length of stay from a <select>
						lengthOfStay = parseInt(lengthOfStay, 10) || 1; // Default to 1 night if not parseable

						if (selectedDates.length > 0) {
							$('.selection').removeClass('hidden');

							//console.log('lengthOfStay', lengthOfStay);
							//console.log('selectedDates', selectedDates);

							var selectedDate = selectedDates[0];
							arrivalDate = selectedDate;

							//console.log('selectedDate', selectedDate);

							// Adjust selectedDate for timezone
							var offset = selectedDate.getTimezoneOffset(); // Get the timezone offset in minutes
							var adjustedDate = new Date(selectedDate.getTime() - (offset * 60 * 1000)); // Adjust the date to local timezone
							var formattedDateCheck = adjustedDate.toISOString().split('T')[0]; // Format adjusted date
							var formattedDate = formatDate(adjustedDate);
							//console.log('formattedDate', formattedDate);

							// Calculate and adjust check-out date for timezone
							var checkOutDate = new Date(selectedDate);
							checkOutDate.setDate(checkOutDate.getDate() + lengthOfStay); // Assuming lengthOfStay is defined somewhere
							var checkOutOffset = checkOutDate.getTimezoneOffset(); // Get the timezone offset for checkOutDate
							var adjustedCheckOutDate = new Date(checkOutDate.getTime() - (checkOutOffset * 60 * 1000)); // Adjust the check-out date to local timezone

							checkoutDate = adjustedCheckOutDate;

							var formattedCheckOutDate = formatDate(adjustedCheckOutDate);
							//console.log('formattedCheckOutDate', formattedCheckOutDate);

							// Find the matching date in currentDates for price information
							var matchingDate = currentDates.find(function (dateObj) {
								return dateObj.startdate === formattedDateCheck;
							});

							// Update HTML elements
							$('#selected-check-in').text(formattedDate); // Display selected check-in date
							$('#selected-check-out').text(formattedCheckOutDate); // Display calculated check-out date
							$('#selected-nights').text(lengthOfStay + ' Nights'); // Display length of stay

							var price = Math.floor(matchingDate.availability);

							var priceText = "£" + price;
							$('#selected-price').text(priceText); // Display price if available

							$('.flatpickr-day-price').removeClass('hidden');
							$('.flatpickr-day').removeClass('selected-available selected-available-end');
							let nextElem = $('.flatpickr-day.selected');	
							for (let i = 0; i < numberOfNights; i++) {
								//console.log('nextElem', nextElem);
								nextElem = nextElem.next('.flatpickr-day');
								if (nextElem.length) {
									//Remoive hidden from price in nextElem
									nextElem.find('.flatpickr-day-price').addClass('hidden');
									nextElem.addClass('selected-available');

									//if last day add .available-next-hover-end
									if (i === numberOfNights - 1) {
										nextElem.addClass('selected-available-end');
									}
								} else {
									break;
								}
							}

							//Convert selectedDate, checkOutDate to yyyy-mm-dd

							var selectedCheckInDate = formatDateYYYYMMDD(selectedDate);


							const params = new URLSearchParams({
								checkin: selectedCheckInDate,
								nights: numberOfNights
							});

							// Get the current URL
							const currentUrl = window.location.href;
							const url = new URL(currentUrl);

							// Set the new search parameters
							url.search = params.toString();

							// Update the browser's URL using pushState
							window.history.pushState({}, '', url);


							
							//IF dataLayer exists
							if (typeof dataLayer !== 'undefined') {

								//Price to int
								price = parseInt(price);
								var propertyName = $('h1').data('property-name');
								var propertyId = $('[data-single-property-id]').data('single-property-id');

								dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
								dataLayer.push({
									event: "view_item",
									ecommerce: {
										currency: "GBP",
										value: price,
										items: [
											{
												item_id: propertyId,
												item_name: propertyName,
											}
										]
									}
								});
							}

						} else {
							$('.selection').addClass('hidden');
						}
					}
				});

				console.log('currentMonth', currentMonth);
				flatpickrInstance.changeMonth(currentMonth);

				function markAvailableDates(instance) {
					//console.log('markAvailableDates');
					const days = instance.days.childNodes;
					days.forEach(dayElem => {
						if (dayElem.dateObj) {
							var offset = dayElem.dateObj.getTimezoneOffset();
							var localDate = new Date(dayElem.dateObj.getTime() - (offset * 60 * 1000));
							var dateStr = localDate.toISOString().split('T')[0];

							//console.log('dateStr', dateStr);

							var matchingDate = currentDates.find(function (dateObj) {
								return dateObj.startdate === dateStr;
							});

							if (matchingDate && matchingDate.availability) {
								// Mark next 7 days as available
								for (let i = 1; i <= numberOfNights; i++) {
									var nextDate = new Date(localDate);
									nextDate.setDate(nextDate.getDate() + i);

									// Adjust nextDate for timezone
									var nextOffset = nextDate.getTimezoneOffset();
									var adjustedNextDate = new Date(nextDate.getTime() - (nextOffset * 60 * 1000));

									var nextDateStr = adjustedNextDate.toISOString().split('T')[0];
									var nextDateFormatted = adjustedNextDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });

									var nextMatchingDate = currentDates.find(function (dateObj) {
										return dateObj.startdate === nextDateStr;
									});

									$('.flatpickr-day[aria-label="' + nextDateFormatted + '"]').addClass('available-next');
								}
							}
						}
					});
				}

				function handleMonthChange(selectedDates, dateStr, instance) {
					const month = instance.currentMonth;
					const year = instance.currentYear;
					const daysInMonth = new Date(year, month + 1, 0).getDate();
					let hasAvailability = false;

					for (let day = 1; day <= daysInMonth; day++) {
						const dateStr = new Date(year, month, day).toISOString().split('T')[0];
						if (currentDates.some(dateObj => dateObj.startdate === dateStr && dateObj.availability)) {
							hasAvailability = true;
							break;
						}
					}

					let content;
					if (!hasAvailability) {
						//Clone the no-availability-month div and insert into .flatpickr-innerContainer
						$('.flatpickr-no-availability-month').remove();
						content = $('.no-availability-month').clone().removeClass('hidden').addClass('flatpickr-no-availability-month absolute h-full bg-[#0a06068c] p-4 sm:p-5');
						$('.flatpickr-innerContainer').append(content);


						//$('.no-availability-month').removeClass('hidden');
						$('.number-of-nights').html($('select[name="nights"]').val());
						//Get month name
						var monthNames = ["January", "February", "March", "April", "May", "June",
							"July", "August", "September", "October", "November", "December"
						];
						var monthName = monthNames[month];
						$('.current-month').html(monthName);
					} else {
						$('.flatpickr-no-availability-month').remove();
					}

				}


				$(document).on('click', '.flatpickr-next-month', function () {
					//Set currentMonth
					console.log('old currentMonth', currentMonth);
					currentMonth++
					console.log('new currentMonth', currentMonth);
				});
				$(document).on('click', '.flatpickr-prev-month', function () {
					//Set currentMonth
					console.log('old currentMonth', currentMonth);
					currentMonth--
					console.log('new currentMonth', currentMonth);
				});

				$(document).on('mouseenter', '.flatpickr-day.available', function () {
					console.log('hover');
					let nextElem = $(this);
					for (let i = 0; i < numberOfNights; i++) {
						nextElem = nextElem.next('.flatpickr-day.available-next');
						if (nextElem.length) {
							nextElem.addClass('available-next-hover');

							//Add hidden to price in nextElem
							nextElem.find('.flatpickr-day-price').addClass('hidden');

							//if last day add .available-next-hover-end
							if (i === numberOfNights - 1) {
								nextElem.addClass('available-next-hover-end');
							}
						} else {
							break;
						}
					}
				});

				$(document).on('mouseleave', '.flatpickr-day.available', function () {
					let nextElem = $(this);
					for (let i = 0; i < numberOfNights; i++) {
						nextElem = nextElem.next('.flatpickr-day.available-next');
						if (nextElem.length) {
							//Remoive hidden from price in nextElem
							nextElem.find('.flatpickr-day-price').removeClass('hidden');

							nextElem.removeClass('available-next-hover available-next-hover-end');
						} else {
							break;
						}
					}
				});


				function findNextEnabledDate() {
					let currentDate = new Date();
					currentDate.setDate(currentDate.getDate() + 1); // Start from the next day of the current date

					// Loop until finding an enabled date
					while (true) {
						let dateStr = currentDate.toISOString().split('T')[0]; // Format the date as a string for comparison

						let isDisabled = disabledDates.some(disabledDate => {
							// Directly compare the strings if disabledDates are strings
							return dateStr === disabledDate;
						});

						if (!isDisabled) {
							// Found an enabled date, break the loop
							break;
						}

						// Move to the next day
						currentDate.setDate(currentDate.getDate() + 1);
					}

					return currentDate;
				}

				function goToNextEnabledMonth() {
					let nextEnabledDate = findNextEnabledDate();
					//console.log('nextEnabledDate', nextEnabledDate);
					flatpickrInstance.jumpToDate(nextEnabledDate);
				}


				//If checkin date exists
				if ($('#check_in').data('checkin-date')) {
					flatpickrInstance.setDate($('#check_in').data('checkin-date'), true);
				} else {
					//goToNextEnabledMonth();
				}

				//Set a 1 second delay to hide loading screen
				setTimeout(function () {
					$('.loading-screen').addClass('hidden');
					removeLoadingAnimation();
				}, 500);
				//$('.loading-screen').addClass('hidden');
			}
		});
	}

	//When select nights is changed, retrieve dates
	$('.single-property select[name="nights"]').on('change', function () {
		retrieveDates();
	});
	
	function initRetrieveDates() {
		retrieveDates();
	}

	if (document.querySelector('.single-properties')) {
		initPropertyImageSwiper();
		initPropertyDate();
		initRetrieveDates();
	}

	// When book-now is clicked, open up featherlight with the .book-now-form div
	$('.book-now').on('click', function (e) {
		e.preventDefault();
		var propertyId = $('[data-single-property-id]').data('single-property-id');

		var numberNights = $('#selected-nights').text().replace(' Nights', '');
		//Convert numberNights to integer
		numberNights = parseInt(numberNights);
		var capacity = $('input[name="capacity"]').val();


		//Convert arrivalDate, checkoutDate to dd/mm/yyyy
		arrivalDate = formatDateDDMMYYYY(arrivalDate);
		checkoutDate = formatDateDDMMYYYY(checkoutDate);

		var cartDetails = {
			action: "cartOpen",
			arrivalDate: arrivalDate,
			departureDate: checkoutDate,
			numberNights: numberNights,
			capacity: capacity,
			cottageID: propertyId,
		};

		//console.log('cartDetails', cartDetails);
		//var iframe = document.getElementById('supercontrolCalendarWidget0');
		//iframe.contentWindow.postMessage(cartDetails, '*');

		window.postMessage(cartDetails, '*');

/*
		$('.book-now').on('click', function () {
			var cartDetails = {
				action: "cartOpen",
				arrivalDate: "07/11/2022",
				departureDate: "14/11/2022",
				numberNights: 7,
				capacity: 2,
				cottageID: 573763,
			};

			// Sending the message to the iframe. 
			// Make sure to replace 'yourIframeId' with the actual ID of your iframe
			var iframe = document.getElementById('supercontrolCalendarWidget0');
			iframe.contentWindow.postMessage(cartDetails, '*');
		});*/


		//$('#booking-form').removeClass('hidden pointer-events-none')

		$('.loading-spinner').removeClass('hidden');
		setTimeout(function () {
			$('.loading-spinner').addClass('hidden');
		}, 2500);
		return false;
	});

	$('.close-booking-form, .booking-bg').on('click', function () {
		$('#booking-form').addClass('hidden pointer-events-none');
	});

	$('.view-all-reviews, .hide-all-reviews').on('click', function (e) {
		e.preventDefault();
		$('.review').toggleClass('hidden');
		$('.view-all-reviews').toggleClass('hidden');
		$('.hide-all-reviews').toggleClass('hidden');
		return false;
	});

	$('.heading-wrapper').on('click', function () {
		var header = $(this);
		header.find('.chevron-icon').toggleClass('rotate-180');
		$(this).parent().find('.content').slideToggle('fast');

		if (header.hasClass('property-map')) {
			initPropertyMap().catch(e => console.error(e));
		}
	});

	async function initPropertyMap() {
		//Get latitude and longitude from data attributes using jquery
		var latitude = $('.property-map').data('property-lat');
		var longitude = $('.property-map').data('property-lng');

		// If latitude and longitude are empty, return false
		if (latitude === '' || longitude === '') {
			console.error('Latitude and Longitude are empty');
			return false;
		}

		const { Map } = await google.maps.importLibrary("maps");
		const markerLibraries = await google.maps.importLibrary("marker");

		// Attach the needed classes to the window object for global access
		window.AdvancedMarkerElement = markerLibraries.AdvancedMarkerElement;
		window.PinElement = markerLibraries.PinElement;

		// Initialize the map
		map = new Map(document.getElementById("property-google-map"), {
			zoom: 8,
			center: { lat: latitude, lng: longitude },
			mapId: 'property_map'
		});

		const parser = new DOMParser();
		// A marker with a custom inline SVG.
		const pinSvgString =
			'<svg class="fill-primary-200" xmlns="http://www.w3.org/2000/svg" width="30" viewBox="0 0 200.16 302.34"><defs/><path  d="M73.2 134.86c-6.73-7.91-12.38-16.93-16.41-27.07-10.7-26.91-6.52-42.48-1.13-50.8 5.54-8.56 14.73-13.55 25.95-14.02 12.47-.53 20.45 6.53 25.06 14.24 9.05-6.99 21.41-12.31 33.21-6.63 10.47 5.06 16.65 14.86 16.95 26.9.52 20.69-15.97 43.25-42.02 57.47-3.72 2.04-7.57 3.94-11.48 5.71 14.73 10.4 31.76 16.69 47.06 18.79 14.6 2.01 28.08.29 38.59-2.24 16.05-40.07 17.95-94.59-15.22-126.9C132.06-10.32 69.28-9.87 27.5 30.2c-31.25 29.98-33 78.53-19.48 117.93 3.22-.35 7.28-.79 12.01-1.34 11-1.56 31.71-5.1 53.17-11.93Z" class="cls-2"/><path d="M140.69 77.89c-.15-6.03-2.79-10.33-7.83-12.76-8.12-3.93-20.26 7.94-23.06 11.33-2 2.43-5.24 3.48-8.27 2.67a8.09 8.09 0 0 1-5.9-6.38c-.27-1.4-3.01-14.08-13.33-13.64-.29.01-.59.03-.9.06-4 .33-9.07 1.79-12.19 6.61-4.7 7.26-3.78 20.07 2.59 36.06 4.15 10.44 10.35 19.49 17.8 27.16 6.01-2.43 11.91-5.16 17.47-8.19 23.65-12.92 33.92-30.85 33.62-42.9ZM148.18 175.45c-20.39-2.8-43.48-12.13-62.14-27.85-32.84 11.66-65.47 15.53-71.63 16.18a155.4 155.4 0 0 0 1.56 3.17c22.03 43.07 35.74 68.02 84.42 135.39 41.58-59.14 57.59-82.14 80.13-127.08-2.39.34-4.86.62-7.4.83-7.75.63-16.16.57-24.95-.64Z" class="cls-2"/><path fill="#fff" stroke-width="0" d="M188.96 157.21c-10.5 2.54-23.98 4.25-38.59 2.24-15.3-2.1-32.33-8.39-47.06-18.79 3.91-1.77 7.76-3.67 11.48-5.71 26.05-14.22 42.54-36.78 42.02-57.47-.3-12.04-6.48-21.84-16.95-26.9-11.79-5.68-24.15-.37-33.21 6.63-4.61-7.71-12.59-14.77-25.06-14.24-11.22.47-20.41 5.46-25.95 14.02-5.39 8.33-9.57 23.9 1.13 50.8 4.04 10.14 9.68 19.16 16.41 27.07-21.47 6.84-42.18 10.37-53.17 11.93-4.73.55-8.79.99-12.01 1.34 1.86 5.41 4 10.65 6.4 15.65 6.16-.65 38.79-4.52 71.63-16.18 18.66 15.72 41.75 25.04 62.14 27.85 8.79 1.21 17.2 1.27 24.95.64 2.54-.21 5.01-.49 7.4-.83 1.32-2.63 2.66-5.33 4.03-8.12 1.56-3.19 3.04-6.51 4.41-9.93ZM71.79 101.83c-6.37-16-7.28-28.81-2.59-36.06 3.12-4.82 8.19-6.28 12.19-6.61.31-.03.61-.04.9-.06 10.32-.44 13.06 12.24 13.33 13.64a8.09 8.09 0 0 0 5.9 6.38c3.03.81 6.27-.24 8.27-2.67 2.8-3.39 14.94-15.26 23.06-11.33 5.05 2.43 7.68 6.73 7.83 12.76.3 12.05-9.97 29.99-33.62 42.9-5.57 3.04-11.46 5.76-17.47 8.19-7.45-7.66-13.65-16.72-17.8-27.16Z"/></svg>';
		const pinSvg = parser.parseFromString(
			pinSvgString,
			"image/svg+xml",
		).documentElement;

		const marker = new window.AdvancedMarkerElement({
			position: { lat: latitude, lng: longitude },
			content: pinSvg,
			map: map, // Directly assign the map here
		});
	}

	// Function to initialize Lottie animations on elements with a specific class name
	function initLoadingAnimation() {
		// Check if 'lottie' is defined
		if (typeof lottie === 'undefined') {
			console.log('Lottie is not loaded');
			displayLoadingFallback();
			return;
		}

		// Find all elements with the class 'loading-animation-container'
		const animationContainers = document.querySelectorAll('.loading-animation-container');

		animationContainers.forEach(container => {
			try {

				// Specify the path to your Lottie animation .lottie file
				const animationPath = '/app/themes/coastalholidays/assets/img/icon-white.json'; // Replace with the actual path

				// Initialize the Lottie animation for each container
				const animation = lottie.loadAnimation({
					container: container, // the DOM element that will contain the animation
					renderer: 'svg', // Rendering mode: 'svg', 'canvas', or 'html'
					loop: true, // Loop the animation
					autoplay: true, // Play the animation immediately
					path: animationPath // The path to the animation .lottie file
				});

				const speedMultiplier = 1.5; // Adjust this value to set the desired speed
				animation.setSpeed(speedMultiplier); 

				// Store the animation instance for potential future use (like stopping/removing)
				container.animationInstance = animation;
			} catch (error) {
				console.error('Error loading loading animation:', error);
				displayLoadingFallback();
			}
		});
	}

	// Function to stop and remove Lottie animations from elements with a specific class name
	function removeLoadingAnimation() {
		const animationContainers = document.querySelectorAll('.loading-animation-container');

		animationContainers.forEach(container => {
			if (container.animationInstance) {
				container.animationInstance.destroy(); // Stop and remove the animation
				delete container.animationInstance; // Clean up the reference
			}
		});
	}

	function displayLoadingFallback() {
		// Find all animation container elements
		const animationContainers = document.querySelectorAll('.loading-animation-container');

		// For each container, insert the custom div as fallback content
		animationContainers.forEach(container => {
			// Remove any existing content
			container.innerHTML = '';

			// Create the custom div for fallback
			const fallbackDiv = document.createElement('div');
			fallbackDiv.className = 'loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mb-4';
			fallbackDiv.style.borderTopColor = 'var(--color-primary-200)'; // Adjust this to match your project's way of defining primary color

			container.appendChild(fallbackDiv);
		});
	}

	$('a[href="#check-availability"]').on('click', function (event) {
		event.preventDefault();

		$('html, body').animate({
			scrollTop: $($.attr(this, 'href')).offset().top
		}, 500);
	});

}